import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getCoupon, getCoupons, createCoupon, updateCoupon } from '../api/coupons.api';
import { ICoupon, IGetCoupons, ICouponReq } from '../models/coupons.model';

interface ICouponState {
  coupons: ICoupon[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: ICouponState = {
  coupons: [],
  isLoading: false
};

const couponSlicer = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    getCouponsStart: (state: ICouponState) => {
      state.coupons = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getCouponsSuccess: (state: ICouponState, action: PayloadAction<IGetCoupons>) => {
      state.coupons = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getCouponsFailure: (state: ICouponState, action: PayloadAction<AxiosError|string>) => {
      state.coupons = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: ICouponState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: ICouponState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: ICouponState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    updateSuccess: (state: ICouponState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  }
});

export const {
  getCouponsStart,
  getCouponsSuccess,
  getCouponsFailure,
  requestStart,
  requestFailure,
  createSuccess,
  updateSuccess,
} = couponSlicer.actions;

export default couponSlicer.reducer;

export const doGetCoupon = (couponCode: number): any => async (dispatch: any) => {
  try {
    dispatch(getCouponsStart());
    const response = await getCoupon(couponCode);
    dispatch(getCouponsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCouponsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetCoupons = (): any => async (dispatch: any) => {
  try {
    dispatch(getCouponsStart());
    const response = await getCoupons();
    dispatch(getCouponsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCouponsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateCoupon = (data: ICouponReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createCoupon(data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doUpdateCoupon = (couponCode: number, data: ICouponReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await updateCoupon(couponCode, data);
    dispatch(updateSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
